module.exports = __webpack_public_path__ + "media/images/favicon-49b6a2eda7a4f7206cf2315ceb7cbc77.svg";